export default __webpack_public_path__ + "static/drinking_fountain_b.cff57749b6d5474f1e0d5603e6a3e399.svg";